import { useMutation } from '@tanstack/react-query';
import { patchCompany } from 'api/resources/company';

export const usePatchCompany = () => useMutation(patchCompany);
